import * as React from 'react';

import { ConfigViewPillar, flatten } from './config.insight.model';
import {
    CustomizePillarsInsightProps,
    CustomizePillarsInsightState,
} from './customize-pillars.insight.model';
import { NestedNodeSelectInsight } from './nested-node-select.insight.component';
import { NestedNode } from './nested-node-select.insight.model';

function mapToNode(pillar: ConfigViewPillar): NestedNode {
    return {
        id: pillar.identifier,
        label: pillar.name,
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        children: pillar.pillars && pillar.pillars.map(mapToNode),
    };
}

function mapToPillar(
    node: NestedNode,
    lookup: ConfigViewPillar[],
): ConfigViewPillar {
    return lookup.find((e) => e.identifier === node.id);
}

class CustomizePillarsInsightImpl extends React.Component<
    CustomizePillarsInsightProps,
    CustomizePillarsInsightState
> {
    constructor(props: CustomizePillarsInsightProps) {
        super(props);

        this._propsToState();
    }

    private _propsToState(): void {
        const pillarsFlatten = flatten(
            this.props.pillars,
            (i) => i,
            (i) => i.pillars,
        );
        const nodes = this.props.pillars.map(mapToNode);
        const selection = this.props.selection.map(mapToNode);
        this.state = { pillarsFlatten, nodes, selection };
    }

    render(): React.ReactNode {
        return (
            <NestedNodeSelectInsight
                nodes={this.state.nodes}
                selection={this.state.selection}
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                onChange={(e) =>
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    this.props.onChange &&
                    this.props.onChange({
                        selected: e.selected.map((ee) =>
                            mapToPillar(ee, this.state.pillarsFlatten),
                        ),
                    })
                }
                canSelect={(node, checked) =>
                    !this.props.canSelect
                        ? true
                        : this.props.canSelect(
                              mapToPillar(node, this.state.pillarsFlatten),
                              checked,
                          )
                }
            />
        );
    }
}

export const CustomizePillarsInsight = CustomizePillarsInsightImpl;
